module.exports = __webpack_public_path__ + "img/2.fc035aec.png";